module.exports = __webpack_public_path__ + "img/error.dc89fc20.svg";